document.addEventListener("DOMContentLoaded", function () {

    const popup = document.getElementById("discount-popup");
    const closeBtn = document.getElementById("popup-close");
    const form = document.getElementById("discount-form");
    const success = document.getElementById("popup-success");
    const copyBtn = document.getElementById("copy-code");
    const code = document.getElementById("discount-code");
    const email = document.getElementById("popup-email");

    if (!popup) return;

    // Don't show again for 7 days
    if (localStorage.getItem("discountPopupClosed")) {
        return;
    }

    // Show popup after 5 seconds
    setTimeout(function () {
        popup.style.display = "flex";
    }, 5000);

    // Close popup
    function closePopup() {
        popup.style.display = "none";

        localStorage.setItem("discountPopupClosed", Date.now());

        setTimeout(function () {
            localStorage.removeItem("discountPopupClosed");
        }, 7 * 24 * 60 * 60 * 1000);
    }

    closeBtn.addEventListener("click", closePopup);

    // Click outside popup
    popup.addEventListener("click", function (e) {
        if (e.target === popup) {
            closePopup();
        }
    });

    // Email submit
    form.addEventListener("submit", function (e) {

        e.preventDefault();

        const value = email.value.trim();

        const pattern =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!pattern.test(value)) {

            alert("Please enter a valid email.");

            return;
        }

        // Hide form
        form.style.display = "none";

        // Show success
        success.style.display = "block";

    });

    // Copy code
    copyBtn.addEventListener("click", function () {

        navigator.clipboard.writeText(code.innerText);

        copyBtn.innerHTML = "Copied ✓";

        setTimeout(function () {

            copyBtn.innerHTML = "Copy";

        }, 2000);

    });

});